export default "__VITE_ASSET__CFTumOM5__"